import { render } from "./full-report.vue?vue&type=template&id=3d1b1592"
import script from "./full-report.vue?vue&type=script&lang=js"
export * from "./full-report.vue?vue&type=script&lang=js"

import "./full-report.vue?vue&type=style&index=0&id=3d1b1592&lang=scss"
script.render = render

export default script